import { render, staticRenderFns } from "./DiyStyleDialog.vue?vue&type=template&id=53f2e626"
import script from "./DiyStyleDialog.vue?vue&type=script&lang=js"
export * from "./DiyStyleDialog.vue?vue&type=script&lang=js"
import style0 from "./DiyStyleDialog.vue?vue&type=style&index=0&id=53f2e626&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports